<app-part-view [uid]="uid" [pageId]="pageId"></app-part-view>
